import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateMemberStatus } from "../api/membersApi";
import type { MemberStatus } from "../api/types";
import { queryKeys } from "../lib/queryKeys";

export interface UpdateStatusArgs {
  id: string;
  status: MemberStatus;
}

export function useUpdateMemberStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: UpdateStatusArgs) => updateMemberStatus(id, status),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.members.all });
    },
  });
}
